import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const behaviourFields = [
  {
    label: 'Use Non-Theme Input',
    name: 'useNonThemeInput',
    editor: 'boolean',
    description: 'If true will customise the input different to the theme',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Keyboard Type',
    name: 'keyboard',
    editor: 'dropdown',
    default: 'default',
    description: 'The keyboard type of the input',
    options: [
      {
        label: 'default',
        value: 'default'
      },
      {
        label: 'number-pad',
        value: 'number-pad'
      },
      {
        label: 'decimal-pad',
        value: 'decimal-pad'
      },
      {
        label: 'numeric',
        value: 'numeric'
      },
      {
        label: 'email-address',
        value: 'email-address'
      },
      {
        label: 'phone-pad',
        value: 'phone-pad'
      },
      {
        label: 'url',
        value: 'url'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Mode',
    name: 'mode',
    editor: 'dropdown',
    default: 'outlined',
    description: 'The mode of input',
    options: [
      {
        label: 'Outlined',
        value: 'outlined'
      },
      {
        label: 'Flat',
        value: 'flat'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Disabled',
    default: false,
    name: 'disabled',
    editor: 'switch',
    description: 'If the field is disabled',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Multi-line',
    default: false,
    name: 'multiline',
    editor: 'switch',
    description: 'If the field is disabled',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: '# of lines',
    name: 'numberOfLines',
    editor: 'number',
    description: 'The number of lines in the field',
    default: '',
    displayWhen: [{ field: 'multiline', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Auto-Capitalize',
    name: 'autoCapitalize',
    description: 'Turn the content of the input to capital letters',
    editor: 'switch',
    default: false,
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'On Blur Action',
    name: 'action',
    default: '',
    editor: 'dropdown',
    description: 'An action to run when this field is blurred.',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  }
];

const fontFields = [
  {
    label: 'Label Font',
    name: 'labelFont',
    editor: 'fontsize',
    description: 'The padding within the input label',
    default: 14,
    displayWhen: [{ field: 'showLabel', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'Input Text Font',
    name: 'font',
    editor: 'fontsize',
    default: 14,
    description: 'The font of the input',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  },
  {
    label: 'Error Message Font',
    name: 'errorMessageFont',
    editor: 'fontsize',
    description: 'The color of the error message',
    group: ELEMENT_ATTRIBUTE_GROUP.FONTS
  }
];

const colorFields = [
  {
    label: 'Label Color',
    name: 'labelColor',
    editor: 'color',
    description: 'The text color of the input label',
    default: '#000000',
    displayWhen: [{ field: 'showLabel', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Text Color',
    name: 'color',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Selection Color',
    name: 'selectionColor',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Outline Color',
    name: 'outlineColor',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Outline Color (Active)',
    name: 'outlineColorActive',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Underline Color',
    name: 'underlineColor',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Underline Color (Active)',
    name: 'underlineColorActive',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the text in the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Background Color',
    name: 'backgroundColor',
    default: '#ffffff',
    editor: 'colorpicker',
    description: 'The background color of the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Border Bottom Color',
    name: 'borderBottomColor',
    default: '#ffffff',
    editor: 'colorpicker',
    description: 'The bottom border color of the input',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Switch Thumb Color (true)',
    name: 'switchThumbOn',
    default: '#48bb78',
    editor: 'colorpicker',
    description:
      'The color of the circular toggle on the switch show for this element when the value is true, if this element is bound to a boolean field type',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Switch Background Color (true)',
    name: 'switchBackgroundOn',
    default: '#c6f6d5',
    editor: 'colorpicker',
    description:
      'The background color of the circular toggle on the switch show for this element when the value is true, if this element is bound to a boolean field type',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Switch Thumb Color (false)',
    name: 'switchThumbOff',
    default: '#ffffff',
    editor: 'colorpicker',
    description:
      'The color of the circular toggle on the switch show for this element when the value is false, if this element is bound to a boolean field type',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Input Switch Background Color (false)',
    name: 'switchBackgroundOff',
    default: '#e2e8f0',
    editor: 'colorpicker',
    description:
      'The background color of the circular toggle on the switch show for this element when the value is false, if this element is bound to a boolean field type',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  },
  {
    label: 'Error Message Color',
    name: 'errorMessageColor',
    default: '#000000',
    editor: 'colorpicker',
    description: 'The color of the error message',
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const contentFields = [
  {
    label: 'Disable Auto-Save',
    name: 'disableAutoSave',
    editor: 'boolean',
    description:
      'If true, the text element will not auto-update the database when it loses focus. Instead, the value in the field will be updated by any on-screen recod navigator. If there is no record navigator element on the same screen and auto-save is disabled for this element, the data in the field will not get saved.',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Local Store Key ',
    name: 'localKey',
    description:
      'If supplied, will set the value of a local store key to the value of this input on blur.',
    editor: 'textbox',
    default: '',
    displayWhen: [],
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description: 'Choose a content type this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    displayWhen: [],

    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Field',
    name: 'sourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying datasource will be used as the value of this element',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Show Label',
    name: 'showLabel',
    description: 'Hide the Label',
    editor: 'switch',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },

  {
    label: 'Label',
    name: 'label',
    editor: 'textbox',
    description: 'The label of the field',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Placeholder Text',
    name: 'placeholder',
    editor: 'textbox',
    description: 'The placeholder to display in the field',
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Display Existing Value',
    name: 'showExistingValue',
    description:
      'Whether to show the existing value for this field in the input when the screen is loaded',
    editor: 'switch',
    default: true,
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Custom Regex',
    name: 'customRegex',
    default: '',
    editor: 'textbox',
    description: 'Custom Regex',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Custom Error Message',
    name: 'customErrorMessage',
    default: '',
    editor: 'textbox',
    description: 'Custom Error Message',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  }
];

const layoutFields = [
  'layout',
  {
    label: 'Label Alignment',
    name: 'labelAlignment',
    editor: 'alignment',
    description: 'The alignment input label',
    default: 'justify-center',
    displayWhen: [{ field: 'showLabel', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Label Margin',
    name: 'labelMargin',
    editor: 'boundary',
    description: 'The margin around the input label',
    default: '10 0 10 0',
    displayWhen: [{ field: 'showLabel', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Label Padding',
    name: 'labelPadding',
    editor: 'boundary',
    description: 'The padding within the input label',
    default: '10 10 10 10',
    displayWhen: [{ field: 'showLabel', operator: '=', value: true }],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Text Alignment',
    name: 'textAlignment',
    editor: 'alignment',
    description: 'The alignment of the input text',
    default: 'justify-left',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Alignment',
    name: 'alignment',
    editor: 'alignment',
    description: 'The alignment of the input text',
    default: 'justify-center',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Margin',
    name: 'margin',
    editor: 'boundary',
    description: 'The margin around the input',
    default: '0 0 0 0',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Padding',
    name: 'padding',
    editor: 'boundary',
    description: 'The padding within the input',
    default: '10 10 10 10',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Border Radius (Top Left)',
    name: 'borderTopLeftRadius',
    editor: 'number',
    description: 'The border radius of the input at the top left corner',
    default: 10,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Border Radius (Top Right)',
    name: 'borderTopRightRadius',
    editor: 'number',
    description: 'The border radius of the input at the top right corner',
    default: 10,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Border Radius (Bottom Right)',
    name: 'borderBottomRightRadius',
    editor: 'number',
    description: 'The border radius of the input at the bottom right corner',
    default: 10,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Border Radius (Bottom Left)',
    name: 'borderBottomLeftRadius',
    editor: 'number',
    description: 'The border radius of the input at the bottom left corner',
    default: 10,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Width',
    name: 'width',
    editor: 'number',
    description: 'The width of the input',
    default: 240,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Label Width',
    name: 'labelWidth',
    editor: 'number',
    description: 'The width of the label',
    default: 110,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Input Height',
    name: 'height',
    editor: 'number',
    description: 'The height of the input',
    default: 45,
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Error Message Alignment',
    name: 'errorMessageAlignment',
    editor: 'alignment',
    description: 'The alignment error message',
    default: 'justify-left',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Error Message Margin',
    name: 'errorMessageMargin',
    editor: 'boundary',
    description: 'The margin around the error message',
    default: '10 0 10 0',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  {
    label: 'Error Message Padding',
    name: 'errorMessagePadding',
    editor: 'boundary',
    description: 'The padding within the error message',
    default: '10 10 10 10',
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  }
];

const FormTextInputElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Text Input',
  icon: 'DocumentTextIcon',
  description: 'Adds a text input form control',
  properties: [
    ...behaviourFields,
    ...fontFields,
    ...colorFields,
    ...contentFields,
    ...layoutFields
  ]
};

export default FormTextInputElementFields;
